import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/** Invalid deal slug / not found — no toast; full-page message only. */
export function DealNotFoundPage({ lang }: { lang: string }) {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 px-4 text-center">
      <h1 className="text-xl font-semibold text-primary font-sans">
        {t('brokerRouting.notFoundTitle', { defaultValue: 'Page not found' })}
      </h1>
      <p className="max-w-md text-sm text-primary/80 font-sans">
        {t('brokerRouting.notFoundBody', {
          defaultValue: 'This link is invalid or the page no longer exists.',
        })}
      </p>
      <Link
        to={`/${lang}/main-brokerage`}
        className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-white hover:opacity-90"
      >
        {t('brokerRouting.backToHome', { defaultValue: 'Back to homepage' })}
      </Link>
    </div>
  );
}
